import React from "react";
import { Button } from 'primereact/button';
import { InputSwitch } from 'primereact/inputswitch';
import { Chart } from 'primereact/chart';
import moment from 'moment';
import { Progress } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../../scss/containers/appointDashboard.scss';
import fetchMethodRequest from '../../../config/service';
import config from "../../../config/config";

export default class AppointmentDashboard extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            calenderWeek: false,
            week: [1, 2, 3, 4, 5, 6, 7],
            fromDate: moment().format("D MMMM YYYY"),
            toDate: '',
            SelectedDay: '',
            formattedObj:{},
            refreshCountDown:0        
        }

    }

    componentDidMount = () => {
        this.setWeek(this.state.fromDate, 'start');
        this.refreshData();
        this.countDown();       
    }

    
  componentWillUnmount = () => {    
    clearInterval(this.refreshInterval);
    clearInterval(this.countDownInterval);
  }

    setWeek = async (date, type) => {
        let fromDate, toDate;
        if (type === 'start') {
            fromDate = moment(date, "D MMMM YYYY").format("D MMMM YYYY");
            toDate = moment(fromDate, "D MMMM YYYY").add(6, 'days').format("D MMMM YYYY");
        } else if (type === 'end') {
            toDate = moment(date, "D MMMM YYYY").format("D MMMM YYYY");
            fromDate = moment(toDate, "D MMMM YYYY").subtract(6, 'days').format("D MMMM YYYY");
        }
        await this.setState({ fromDate: fromDate, toDate: toDate });
        this.getDashboardData(moment(fromDate,"D MMMM YYYY").format("MM/DD/YYYY"),moment(toDate,"D MMMM YYYY").format("MM/DD/YYYY"));
        this.setDays(fromDate);

    }

    setDays = (date) => {
        let week = this.state.week.map((elem, i) => {
            let datet = moment(date, "D MMMM YYYY").add(i, 'days').format("ddd, MMM D");           
            return {date:datet,day:moment(date, "D MMMM YYYY").add(i, 'days').weekday()};
        });
        this.setState({ week: week });
    }


    onClickPrevOrNext = (type) => {
        if (type === 'prev') {
            this.setWeek(moment(this.state.fromDate, "D MMMM YYYY").subtract(1, 'days').format("D MMMM YYYY"), 'end');
        } else if (type === 'next') {
            this.setWeek(moment(this.state.toDate, "D MMMM YYYY").add(1, 'days').format("D MMMM YYYY"), 'start');
        }
    }

    displayValueTemplate = (value) => {
        return (
            <React.Fragment>
                {value}/<b>100</b>
            </React.Fragment>
        );
    }

    getPercentage = (value, total) => {
        return ((value / total) * 100);
    }

    onClickToday = async() => {
        await this.setState({fromDate: moment().format("D MMMM YYYY"),SelectedDay: moment().format("ddd, MMM D"),});
        this.setWeek(this.state.fromDate, 'start');
        this.setFilterCriteria(moment().format(config.dayYearDateFormat),moment().add(1, 'days').format(config.dayYearDateFormat),'filter')

    }

    getDashboardData = (fromDate,toDate) => {

        fetchMethodRequest('GET',`dashboard/getAppointmentScreenData?fromDate=${fromDate}&toDate=${toDate}`).then(res => {
            if(res && res.details){
                this.formatData(res.details);
            }
        })
    }

    formatData = (data) => {
        if (data && data.length > 0) {
            let dataObj = {};
            data.forEach((elem) => {
                const dateProp = elem.date ? moment(elem.date).format("ddd, MMM D") : '';
                if (dateProp) {
                    if(!dataObj[dateProp]){
                        dataObj[dateProp] = {};
                    }
                    dataObj[dateProp][elem.modalities] = {total:elem.totalcount,booked:elem.bookedcount};
                    dataObj[dateProp][elem.modalities]['percentage'] = this.getPercentage(elem.bookedcount,elem.totalcount);
                }
            });
            const tObj = JSON.parse(JSON.stringify(dataObj));
            for(const day in tObj){
                let total = 0;
                for(const scan in tObj[day] ){
                    total = total + tObj[day][scan].booked;
                }
                dataObj[day]['totalBooked'] = total;
            }
            this.setState({formattedObj:dataObj})
        }

    }

    refreshData = () => {
       this.refreshInterval = setInterval(() => {
            this.setFilterCriteria('','','refresh'); 
            this.setState({refreshCountDown:0,SelectedDay:''});           
        }, (60000 * 2));
    }

    countDown = () => {
        this.countDownInterval = setInterval(() => {
            let c = this.state.refreshCountDown;
            c = c + 1;
            this.setState({refreshCountDown:c});
        },60000)
    }

    onClickDay = (day) => {
        this.setState({SelectedDay:day});
        this.setFilterCriteria(moment(day,'ddd, MMM D').format('MM/DD/YYYY'),moment(day,'ddd, MMM D').add(1, 'days').format('MM/DD/YYYY'),'filter')
    }

    onSelectCalendarWeek = (value) => {
        this.setState({calenderWeek:value})
        if(value){
            this.setFilterCriteria(moment(this.state.fromDate,'D MMMM YYYY').format(config.dayYearDateFormat),moment(this.state.toDate,'D MMMM YYYY').format(config.dayYearDateFormat),'filter');
        }else {
            this.setFilterCriteria('','','refresh');
        }
    }

    setFilterCriteria = (fromDate,toDate,type) => {
        let fc = { limit: 20, page: 1, criteria: [], direction: 'desc', softfield: 'scheduledDate' };
        if (type === 'filter' && fromDate && toDate) {
            let criteria = [{ "key": "scheduledDate", "value": `${fromDate} 00:00:00Z`, "type": "gte" },
            { "key": "scheduledDate", "value": `${toDate} 00:00:00Z`, "type": "lte" }];
            fc.criteria = criteria;
        }
        this.props.getAppointmentsData(fc);
    }

    render() {
        const data = {
            labels: ['A', 'B', 'C'],
            datasets: [
                {
                    data: [20, 30],
                    backgroundColor: [
                        "#FF6384",
                        "gray",

                    ],
                    hoverBackgroundColor: [
                        "#FF6384",
                        "#36A2EB"

                    ]
                }],

        };

        const options = {

            legend: {
                display: false
            },
            labels: {
                display: false,
            },
            tooltips: {
                enabled: false
            }


        }
        return (
            <div className="appDash-wrapper mt-4">
                <div className="appDash-wrapper-header pb-1 border-bottom">
                    <div className="appDash-wrapper-header-item ml-2 mt-1">
                        <Button label="Today" className="p-button-sm mr-2" onClick={()=>{this.onClickToday()}} />
                        <InputSwitch checked={this.state.calenderWeek} onChange={(e) => this.onSelectCalendarWeek(e.value)} />
                        &nbsp;Calendar Week
                    </div>
                    <div className="appDash-wrapper-header-item date-show">
                        <FontAwesomeIcon
                            icon='chevron-left'
                            className='mr-3 pointer' size="lg"
                            onClick={(e) => { this.onClickPrevOrNext('prev') }}

                        />
                        {this.state.fromDate} - {this.state.toDate}
                        <FontAwesomeIcon
                            icon='chevron-right'
                            className='ml-3 pointer' size="lg"
                            onClick={(e) => { this.onClickPrevOrNext('next') }}

                        />
                    </div>
                    <div className="appDash-wrapper-header-item mr-2">
                        Last synced {this.state.refreshCountDown} minutes ago
                    </div>
                </div>
                <div className="appDash-wrapper-info mb-2">
                    {this.state.week.map((elem) => {
                        return <div className={elem.date === this.state.SelectedDay ? 'appDash-wrapper-info-item border-right selected-box p-3 pointer' :
                         elem.day === 0 ? 'appDash-wrapper-info-item border-right close-box p-3 pointer': 
                         'appDash-wrapper-info-item border-right pointer p-3'} 
                                onClick={()=>{this.onClickDay(elem.date)}}>
                            <div className="appDash-wrapper-info-item-top">
                                <div>{elem.date}</div>
                                <div className="badge badge-primary">
                                    {this.state.formattedObj[elem.date] && 
                                    this.state.formattedObj[elem.date].totalBooked ? 
                                    this.state.formattedObj[elem.date].totalBooked : 0}
                                    </div>
                            </div>
                            { elem.day !== 0 &&
                            <div className="appDash-wrapper-info-item-main mt-2">
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>CT</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['CT'] ?
                                        <div>{ this.state.formattedObj[elem.date]['CT'].booked ? this.state.formattedObj[elem.date]['CT'].booked : 0 }/{  this.state.formattedObj[elem.date]['CT'].total ? this.state.formattedObj[elem.date]['CT'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['CT'] && 
                                            this.state.formattedObj[elem.date]['CT'].percentage ? this.state.formattedObj[elem.date]['CT'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >

                                    </Progress>
                                </div>
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>CTA</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['CTA'] ?
                                        <div>{ this.state.formattedObj[elem.date]['CTA'].booked ? this.state.formattedObj[elem.date]['CTA'].booked : 0 }/{  this.state.formattedObj[elem.date]['CTA'].total ? this.state.formattedObj[elem.date]['CTA'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2"
                                        color="success"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['CTA'] && 
                                            this.state.formattedObj[elem.date]['CTA'].percentage ? this.state.formattedObj[elem.date]['CTA'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >
                                    </Progress>
                                </div>
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>MRA</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['MRA'] ?
                                        <div>{ this.state.formattedObj[elem.date]['MRA'].booked ? this.state.formattedObj[elem.date]['MRA'].booked : 0 }/{  this.state.formattedObj[elem.date]['MRA'].total ? this.state.formattedObj[elem.date]['MRA'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2 bg-progress-blueviolet"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['MRA'] && 
                                            this.state.formattedObj[elem.date]['MRA'].percentage ? this.state.formattedObj[elem.date]['MRA'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >

                                    </Progress>
                                </div>
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>MRI</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['MRI'] ?
                                        <div>{ this.state.formattedObj[elem.date]['MRI'].booked ? this.state.formattedObj[elem.date]['MRI'].booked : 0 }/{  this.state.formattedObj[elem.date]['MRI'].total ? this.state.formattedObj[elem.date]['MRI'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2 bg-progress-blueviolet"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['MRI'] && 
                                            this.state.formattedObj[elem.date]['MRI'].percentage ? this.state.formattedObj[elem.date]['MRI'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >

                                    </Progress>
                                </div>
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>PET</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['PET'] ?
                                        <div>{ this.state.formattedObj[elem.date]['PET'].booked ? this.state.formattedObj[elem.date]['PET'].booked : 0 }/{  this.state.formattedObj[elem.date]['PET'].total ? this.state.formattedObj[elem.date]['PET'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2 bg-progress-blueviolet"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['PET'] && 
                                            this.state.formattedObj[elem.date]['PET'].percentage ? this.state.formattedObj[elem.date]['PET'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >

                                    </Progress>
                                </div>
                                <div >
                                    <div className="d-flex justify-content-between">
                                        <div>US</div>
                                        {this.state.formattedObj[elem.date] && this.state.formattedObj[elem.date]['US'] ?
                                        <div>{ this.state.formattedObj[elem.date]['US'].booked ? this.state.formattedObj[elem.date]['US'].booked : 0 }/{  this.state.formattedObj[elem.date]['US'].total ? this.state.formattedObj[elem.date]['US'].total : 0 }</div> : <div>0/0</div> }
                                    </div>
                                    <Progress
                                        className="my-2 bg-progress-blueviolet"
                                        value={this.state.formattedObj[elem.date] && 
                                            this.state.formattedObj[elem.date]['US'] && 
                                            this.state.formattedObj[elem.date]['US'].percentage ? this.state.formattedObj[elem.date]['US'].percentage : 0 }
                                        style={{
                                            height: '3px'
                                        }}
                                    >

                                    </Progress>
                                </div>
                            </div>
                    }
                            {/* <div className="appDash-wrapper-info-item-main mt-2 row">
                                <div className="mb-2 col-md-3 text-center">
                                    <Chart type="pie" data={data}  options={options} />
                                    CT
                                </div>
                                <div className="mb-2 col-md-3 text-center">
                                    <Chart type="pie" data={data}  options={options} />
                                    MRI
                                </div>
                                <div className="mb-2 col-md-3 text-center">
                                    <Chart type="pie" data={data}  options={options} />
                                    PT
                                </div>

                            </div> */}

                        </div>
                    })

                    }
                </div>
            </div>

        )
    }
}